import http from '../../../base/api/public'
let service = require('@/../config/serviceList');
let sysConfig = require('@/../config/sysConfig');
let apiPre = sysConfig.apiPre;
export default {

  getAnalyseData (params) {
    return http.requestPost(apiPre + service.member + '/member/customerFlow/customerFlowStatistics', params)
  }

}



// WEBPACK FOOTER //
// ./src/module/dataCenter/api/customerAnalusis.js